import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Avatar,
  IconButton,
} from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';

export const AnimalList: React.FC = () => {
  // Mock data - in a real app, this would come from an API
  const animals = [
    { id: '127', name: 'Vaca Malhada 127', breed: 'Nelore', age: '3 anos', status: 'Saudável', location: 'Pasto A-3' },
    { id: '045', name: 'Touro Brahman 045', breed: 'Brahman', age: '5 anos', status: 'Saudável', location: 'Pasto B-1' },
    { id: '089', name: 'Vaca Jersey 089', breed: 'Jersey', age: '2 anos', status: 'Atenção', location: 'Pasto A-2' },
    { id: '156', name: 'Bezerro 156', breed: 'Nelore', age: '6 meses', status: 'Saudável', location: 'Pasto C-1' },
    { id: '203', name: 'Vaca Holandesa 203', breed: 'Holandesa', age: '4 anos', status: 'Saudável', location: 'Pasto A-1' },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, color: DESIGN_TOKENS.colors.primary[700] }}>
        Lista de Animais
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: DESIGN_TOKENS.colors.text.secondary }}>
        Total de {animals.length} animais cadastrados
      </Typography>

      <TableContainer component={Paper} elevation={1}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: DESIGN_TOKENS.colors.background.elevated }}>
              <TableCell sx={{ fontWeight: 600 }}>Animal</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Raça</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Idade</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Localização</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {animals.map((animal) => (
              <TableRow key={animal.id} sx={{ '&:hover': { backgroundColor: DESIGN_TOKENS.colors.background.elevated } }}>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar sx={{ bgcolor: DESIGN_TOKENS.colors.organization.farm, width: 32, height: 32 }}>
                      <img
                        src="/vaca.svg"
                        alt="Ícone de vaca"
                        style={{ width: 18, height: 18 }}
                      />
                    </Avatar>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {animal.name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
                        ID: #{animal.id}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>{animal.breed}</TableCell>
                <TableCell>{animal.age}</TableCell>
                <TableCell>
                  <Chip
                    label={animal.status}
                    size="small"
                    color={animal.status === 'Saudável' ? 'success' : 'warning'}
                  />
                </TableCell>
                <TableCell>{animal.location}</TableCell>
                <TableCell>
                  <IconButton size="small" sx={{ color: DESIGN_TOKENS.colors.organization.farm }}>
                    <Visibility />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};